"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationsQueueProvider = void 0;
const React = __importStar(require("react"));
const MutationsQueue = __importStar(require("@genesys/graphql-mutations-queue"));
const Contexts = __importStar(require("../contexts"));
const GraphQLEntityState = __importStar(require("../graphql-entity-state"));
class MutationsQueueProvider extends React.Component {
    constructor(props) {
        super(props);
        this.queue = (queueId, queueMutationDescriptions) => {
            this.props.dispatch(GraphQLEntityState.queueMutations(queueId, queueMutationDescriptions));
        };
        this.deQueue = (queueId, queuedMutations) => {
            this.props.dispatch(GraphQLEntityState.deQueueMutations(queueId, queuedMutations));
        };
        this.flushQueue = async (queueId) => {
            const queueState = this.state.mutationQueues[queueId] || MutationsQueue.EmptyQueue;
            const results = await MutationsQueue.sendMutations(queueState, GraphQLEntityState.getObjectToId, this.props.includeServerLog, this.props.clientConfigContextValue.graphqlEndpoint, this.props.clientConfigContextValue.authorization);
            const mutationsToDequeue = results.map(m => m.mutation);
            let allNewEntities = {};
            const cachePatches = [];
            for (const r of results) {
                allNewEntities = Object.assign(Object.assign({}, allNewEntities), r.newEntities);
                cachePatches.push(...r.cachePatches);
            }
            this.props.dispatch(GraphQLEntityState.mergeUserEntitiesAndDeuqueQueuedMutations(allNewEntities, cachePatches, queueId, mutationsToDequeue));
            return results;
        };
        this.discardQueue = (queueId) => {
            this.props.dispatch(GraphQLEntityState.discardMutationsQueue(queueId));
        };
        this.applyPatches = (cachePatches) => {
            this.props.dispatch(GraphQLEntityState.applyCachePathes(cachePatches));
        };
        this.state = {
            queue: this.queue,
            deQueue: this.deQueue,
            discardQueue: this.discardQueue,
            flushQueue: this.flushQueue,
            applyPatches: this.applyPatches,
            mutationQueues: {}
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.mutationQueues !== state.mutationQueues) {
            return {
                mutationQueues: props.mutationQueues
            };
        }
        return null;
    }
    render() {
        return (React.createElement(Contexts.mutationsQueueContext.Provider, { value: this.state }, React.Children.only(this.props.children)));
    }
}
exports.MutationsQueueProvider = MutationsQueueProvider;
//# sourceMappingURL=mutations-queue-provider.js.map